import React, { useEffect, useRef, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Box,
    Typography,
    Slide,
    Avatar,
    Tooltip,
    Paper,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import PersonOutlined from "@mui/icons-material/PersonOutlined";
import SupportAgentOutlined from "@mui/icons-material/SupportAgentOutlined";
import { addCommentaire } from "../../../services/CommentaireService";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function ChatPopup({
                                      open,
                                      handleClose,
                                      messages = [],
                                      onSend,
                                      title = "Discussion",
                                      demandeId,
                                      traiteePar,
                                      meType = "Direction",
                                  }) {
    const [input, setInput] = useState("");
    const [sending, setSending] = useState(false);
    const listRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const el = listRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            el.scrollTop = el.scrollHeight;
        });
    }, [open, messages]);

    const handleSend = async () => {
        const trimmed = input.trim();
        if (!trimmed || sending) return;

        try {
            setSending(true);
            await addCommentaire({
                demandeId,
                contenu: trimmed,
                auteurType: meType,
                traiteePar,
            });
            setInput("");
            onSend?.();
        } catch (err) {
            console.error("Erreur lors de l’envoi du commentaire", err);
        } finally {
            setSending(false);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    const isMe = (t = "") =>
        t?.toLowerCase().trim() === meType.toLowerCase().trim();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            slotProps={{ paper: { sx: { borderRadius: 3, overflow: "hidden" } } }}
            TransitionComponent={Transition}
        >
            <Box
                sx={{
                    background: "linear-gradient(90deg, #2193b0, #6dd5ed)",
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#fff",
                }}
            >
                <Typography variant="h6" fontWeight={800}>
                    {title}
                </Typography>
                <Tooltip title="Fermer">
                    <IconButton onClick={handleClose} sx={{ color: "white" }}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <DialogContent
                ref={listRef}
                sx={{
                    bgcolor: "#f5f8fb",
                    height: 360,
                    overflowY: "auto",
                    px: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                }}
            >
                {messages.length > 0 ? (
                    messages.map((msg, i) => {
                        const mine = isMe(msg.auteurType);
                        return (
                            <Box
                                key={`${msg.date || i}-${i}`}
                                display="flex"
                                justifyContent={mine ? "flex-end" : "flex-start"}
                                alignItems="flex-end"
                                gap={1}
                            >
                                {!mine && (
                                    <Avatar sx={{ width: 28, height: 28, bgcolor: "#90caf9" }}>
                                        <SupportAgentOutlined fontSize="small" />
                                    </Avatar>
                                )}

                                <Paper
                                    elevation={0}
                                    sx={{
                                        px: 1.5,
                                        py: 1,
                                        maxWidth: "78%",
                                        borderRadius: 2,
                                        bgcolor: mine ? "#e3f2fd" : "#bbdefb",
                                        border: "1px solid rgba(0,0,0,0.06)",
                                    }}
                                >
                                    <Typography variant="body2">{msg.contenu}</Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{ display: "block", color: "text.secondary", mt: 0.5 }}
                                    >
                                        {msg.date}
                                    </Typography>
                                </Paper>

                                {mine && (
                                    <Avatar sx={{ width: 28, height: 28, bgcolor: "#64b5f6" }}>
                                        <PersonOutlined fontSize="small" />
                                    </Avatar>
                                )}
                            </Box>
                        );
                    })
                ) : (
                    <Box sx={{ m: "auto", textAlign: "center", color: "text.secondary" }}>
                        <SupportAgentOutlined />
                        <Typography variant="body2" mt={1}>
                            Aucun commentaire pour l’instant.
                        </Typography>
                    </Box>
                )}
            </DialogContent>

            <DialogActions
                sx={{
                    px: 2,
                    pb: 2,
                    pt: 1,
                    bgcolor: "#f5f8fb",
                }}
            >
                <TextField
                    fullWidth
                    placeholder="Écrire un message… (Entrée = envoyer, Maj+Entrée = saut de ligne)"
                    multiline
                    maxRows={4}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={onKeyDown} slotProps={{ input: {
                        sx: { borderRadius: "24px", bgcolor: "#fff" },
                        endAdornment: (
                            <IconButton
                                onClick={handleSend}
                                color="primary"
                                disabled={!input.trim() || sending}
                            >
                                {sending ? <CircularProgress size={18} /> : <SendIcon />}
                            </IconButton>
                        ),
                    } }}
                />
            </DialogActions>
        </Dialog>
    );
}
